// extracted by mini-css-extract-plugin
module.exports = {"base":"styles-m__base__2o2qW","label-story":"styles-m__label-story__1u1Fr"};